

































































































import { defineComponent, reactive } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Layout from '@/components/organisms/common/Layout.vue'
import QuestionDetailTable from '@/components/organisms/questionnaire/QuestionDetailTable.vue'
import QuestionnairePageTable from '@/components/organisms/questionnaire/QuestionnairePageTable.vue'
import useVuex from '@/utils/useVuex'
import { UserState } from '@/types/store'
import { useQuestionnaireDetail } from '@/composable/questionnaire/useQuestionnaireDetail'
import { QuestionnaireActions } from '@/store/questionnaire/actions'

type Props = {}

export default defineComponent({
  name: 'QuestionnaireDetail',
  props: {},
  components: { Layout, QuestionnairePageTable, QuestionDetailTable },
  setup(_props: Props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      // mockReceiptId: null,
    })

    const { questionnaire, pages } = useQuestionnaireDetail(context)

    const { copyQuestionnaire } = useActions<QuestionnaireActions>(
      'questionnaire',
      ['copyQuestionnaire'],
    )

    const isAutomatic = context.root.$route.path.includes('automatic')
    const qType = isAutomatic ? 'automatic' : 'manual'
    const answerUrl = `${qType}-questionnaire-answer`

    const changeStatus = async (status: string) => {
      if (
        window.confirm(
          `このアンケートを${
            status === 'private'
              ? '非公開に'
              : status === 'public'
              ? '公開'
              : '終了'
          }します。よろしいですか。`,
        ) === false
      ) {
        return
      }
      await store.dispatch('questionnaire/updateQuestionnaire', {
        id: questionnaire.value.id,
        body: { status },
      })
      context.root.$router.push(`/${qType}`)
    }

    const deleteQuestionnaire = async () => {
      if (
        window.confirm(`このアンケートを削除します。よろしいですか。`) === false
      ) {
        return
      }
      await store.dispatch('questionnaire/deleteQuestionnaire', {
        id: questionnaire.value.id,
      })
      context.root.$router.go(-1)
    }

    const copy = async () => {
      if (
        window.confirm(
          `このアンケートのコピーを作成します。よろしいですか。`,
        ) === false
      ) {
        return
      }
      await copyQuestionnaire({ id: questionnaire.value.id })
      context.root.$router.go(-1)
    }

    const additionalIssue = async () => {
      if (
        window.confirm(
          `${questionnaire.value.totalLimit}件追加配信を行います。よろしいですか。`,
        ) === false
      ) {
        return
      }
      await store.dispatch('questionnaire/additionalIssueQuestionnaire', {
        id: questionnaire.value.id,
      })
    }

    // const genMock = async () => {
    //   if (state.mockReceiptId === null || isNaN(Number(state.mockReceiptId))) {
    //     return
    //   }
    //   const generatedUrl = await store.dispatch('questionnaire/genMock', {
    //     id: questionnaire.value.id,
    //     receiptId: Number(state.mockReceiptId),
    //   })
    //   window.alert('COPY URL IN COSOLE')
    //   console.info(generatedUrl)
    // }

    return {
      state,
      questionnaire,
      pages,
      changeStatus,
      deleteQuestionnaire,
      isAutomatic,
      qType,
      answerUrl,
      copy,
      additionalIssue,
      // genMock,
    }
  },
})
